import { clsx } from 'clsx'
import { type FC } from 'react'

import {
  type UserDocumentPosition,
  type UserDocumentPositionERx,
} from '@redteclab/api/clients/bully'

import { NextLink } from '../../next-link'
import { userSubOrderAccessorIsProductErx } from '../model/userSubOrderAccessorIsProductErx'

import { OrderImageItem } from './OrderImageItem'

const MAX_ITEMS = 3

export const OrderDetailsProductImageList: FC<{
  enableLinks?: boolean
  products: (UserDocumentPosition & UserDocumentPositionERx)[]
  unlimitedItems?: boolean
}> = ({ enableLinks, products, unlimitedItems }) => {
  const userProducts = unlimitedItems ? products : products.slice(0, MAX_ITEMS)

  return (
    <ul className={clsx('mt-3 flex gap-2', unlimitedItems && 'flex-wrap')}>
      {userProducts.map((item) => {
        if (!item.itemName) {
          return null
        }

        const isErx = userSubOrderAccessorIsProductErx(item)
        const key = `${isErx ? 'erx-' : ''}${item.itemName}`

        return enableLinks && item.canonicalURL ? (
          <li key={key}>
            <NextLink
              href={item.canonicalURL}
              rel="noopener noreferrer"
              target="_blank"
            >
              <OrderImageItem
                alt={item.itemName}
                isERx={isErx}
                src={item.thumbnailURL}
              />
            </NextLink>
          </li>
        ) : (
          <li key={key}>
            <OrderImageItem
              alt={item.itemName}
              isERx={isErx}
              src={item.thumbnailURL}
            />
          </li>
        )
      })}
      {!unlimitedItems && products.length > MAX_ITEMS && (
        <li className="flex items-center rounded-s bg-light-primary-medium px-2 font-medium text-dark-primary-strong">
          <span>{`+${products.length - MAX_ITEMS}`}</span>
        </li>
      )}
    </ul>
  )
}
